module.exports = __webpack_public_path__ + "img/会诊卡-选中.9b425d4f.png";